if (!window.AbortError) {
	window.AbortError = class extends Error {
		constructor() {
			super('Aborted');
		}
	}
}

class RESTError extends Error { }

let REST = {
	prefix: '',
	
	getURL(path) {
		return REST.prefix + path;
	},

	getExtraHeaders(method, path) {
		return {};
	},

	reportPerformance(start_ts, server_timing, info) {
	},

	async uncachedRequest({path, body, method, headers, nonJsonOk, signal}) {
		let start_ts = performance.now();

		try {
			let res = await fetch(REST.getURL(path), {
				method,
				mode: 'same-origin',
				headers: {
					Accept: 'application/json',
					'X-Anti-CSRF': '1',
					...this.getExtraHeaders(method, path, arguments[0]),
					...headers,
				},
				body,
				cache: 'default',
				signal,
			});

			if (res.ok) {
				try {
					let data = await res.json();
					REST.reportPerformance(start_ts, res.headers.get('server-timing'), {method, path, status: res.status});
					return data;
				} catch (ex) {
					if (ex instanceof AbortError || ex instanceof DOMException) {
						throw ex;
					}

					if (!nonJsonOk) {
						throw new RESTError(`${method} ${path} failed to parse response JSON`);
					}
				}
			} else {
				let errData = {};
				try {
					errData = await res.json();
				} catch (ex) {}

				REST.reportPerformance(start_ts, res.headers.get('server-timing'), {method, path, status: res.status});

				let err = new RESTError((errData || {}).error || `${method} ${path} failed with status: ${res.status}`);
				err.status = res.status;
				err.detail = (errData || {}).detail;
				err.reason = (errData || {}).reason;
				err.serverError = (errData || {}).error;
				throw err;
			}
		} catch (ex) {
			REST.reportPerformance(start_ts, null, {method, path, status: 0, error: ex.message});

			if (ex instanceof DOMException) {
				throw new AbortError();
			}

			if (ex instanceof RESTError || ex instanceof AbortError) {
				throw ex;
			}

			throw new RESTError(`${method} ${path} ${ex.message}`);
		}
	},

	request(opts) {
		if (!opts.cache) {
			return this.uncachedRequest(opts);
		}

		let key = opts.method + ':' + opts.path;
		let cachedResult = opts.cache.get(key);
		if (cachedResult) {
			return cachedResult;
		}

		let promise = this.uncachedRequest(opts);

		opts.cache.set(key, promise);

		return promise.then(res => {
			return res;
		}, err => {
			opts.cache.delete(key);
			throw err;
		});
	},

	GET(path, params, opts) {
		if (params) {
			params = {...params};

			for (let [k, v] of Object.entries(params)) {
				if (v === null || v === undefined) {
					delete params[k];
				}
			}
		}

		let up = params ? new URLSearchParams(params) : null;

		return REST.request({
			method: 'GET',
			path: path + (up ? '?' + up.toString() : ''),
			...opts,
		});
	},

	POST(path, data, opts) {
		return REST.request({
			method: 'POST',
			path,
			headers: {
				'Content-Type': 'application/json;charset=utf-8',
			},
			body: JSON.stringify(data),
			...opts,
		});
	},

	PUT(path, data, opts) {
		return REST.request({
			method: 'PUT',
			path,
			headers: {
				'Content-Type': 'application/json;charset=utf-8',
			},
			body: JSON.stringify(data),
			...opts,
		});
	},

	DELETE(path, opts) {
		return REST.request({
			method: 'DELETE',
			path,
			nonJsonOk: true,
			...opts,
		});
	},

	Cache: class {
		constructor() {
			this.clear();
		}

		get(key) {
			return this.keys.get(key);
		}

		set(key, val) {
			this.keys.set(key, val);
		}

		clear() {
			this.keys = new Map;
		}
	},
};
